import { fetcher } from 'src/config/request';
import { BulkActionEndpoints } from './endpoints';
export const BulkActionService = {
    async publish(payload) {
        return (await fetcher.put(BulkActionEndpoints.publish(), {
            ...payload,
            notifyByEmail: false,
            published: true
        })).data;
    },
    async unpublish(payload) {
        return (await fetcher.put(BulkActionEndpoints.publish(), {
            ...payload,
            notifyByEmail: false,
            published: false
        })).data;
    },
    async delete(payload) {
        return (await fetcher.put(BulkActionEndpoints.delete(), payload)).data;
    }
};
